// Traits currently populated by the Trait GASv3 builder:

// https://data-portal.internal.atlassian.com/targeting/traits/b8195373-3105-44b3-8a66-ef72b9b0a184
export const TRELLO_JIRA_CO_USERS_VNEXT = 'trello_jira_co_users_vnext';

// https://data-portal.internal.atlassian.com/targeting/traits/f52560f9-671d-4e4a-8120-1bd31d3eff04
export const TRELLO_GA_MODAL_DATE = 'trello_ga_modal_date';

// https://data-portal.internal.atlassian.com/targeting/traits/deab0cfc-1f98-482d-bbc3-d7041907e3ab
export const TRELLO_UI_BUTTON_CLICKED_ONBOARDINGLISTSPOTLIGHTDONEBUTTON_FIRST_TIME =
  'trello_ui_button_clicked_onboardinglistspotlightdonebutton_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/00c2ee11-511d-4ee0-ba40-d1d8130cd195
export const TRELLO_UI_BUTTON_CLICKED_CONNECTACCOUNTBUTTON_PLANNERSCREEN_CHANGED =
  'trello_ui_button_clicked_connectaccountbutton_plannerscreen_changed';

// https://data-portal.internal.atlassian.com/targeting/traits/38cf4018-8eb8-49b3-b0e2-6c90ddf089f7
export const TRELLO_OPERATIONAL_PLANNERDISCOVERYSPOTLIGHTELIGIBILITY_EXCLUDED_CHANGED =
  'trello_operational_plannerdiscoveryspotlighteligibility_excluded_changed';

// https://data-portal.internal.atlassian.com/targeting/registry/2b4d84c1-0caa-46af-9fca-075b18824f7a
export const SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID =
  'segment_trello_has_learned_more_inbox_quick_capture_real-time_aaid';

// https://data-portal.internal.atlassian.com/targeting/registry/399ca46e-2335-4f35-aa6b-70a814b2ac30
export const SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID =
  'segment_trello_has_used_inbox_quick_capture_real-time_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/0842a575-468d-4dca-992d-61c71e7a641a
export const TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH =
  'trello_track_card_added_quick_capture_changed_batch';

// https://data-portal.internal.atlassian.com/targeting/traits/960ae1af-e26d-423a-82e6-dca3c81f99f9
export const TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH =
  'trello_ui_clicked_quick_capture_prompt_changed_batch';

// https://data-portal.internal.atlassian.com/targeting/registry/51d9da34-54e8-486b-843e-97e1e543f332
export const SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_INFO_PANEL_QC_AAID =
  'segment_trello_has_learned_more_inbox_info_panel_qc_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/7545f420-9c40-49ef-91ea-efb50723f5b8
export const TRELLO_HAS_USED_PAID_PLANNER_ACTIONS_CHANGED =
  'trello_has_used_paid_planner_actions_changed';

// https://data-portal.internal.atlassian.com/targeting/traits/ecd7d2fa-56ab-482c-8b16-b3d0db735efc
export const TRELLO_PLANNER_VIEWED_REAL_TIME_AAID =
  'trello_planner_viewed_real_time_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/795ca790-43c9-4a40-9941-e356ad014eae
export const TRELLO_UI_SECTION_VIEWED_WORKSPACEWELCOMEMESSAGE_WORKSPACEBOARDSHOMESCREEN_FIRST_TIME =
  'trello_ui_section_viewed_workspacewelcomemessage_workspaceboardshomescreen_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/f88fc94c-60d0-419b-8c5a-b27aad0e28c1
export const TRELLO_UI_FLAG_VIEWED_INVITEEBOARDWELCOMEMESSAGE_BOARDCREATIONSCREEN_FIRST_TIME =
  'trello_ui_flag_viewed_inviteeboardwelcomemessage_boardscreen_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/4059d979-842e-4b77-a0cd-9dea4cb6af85
export const NEW_INVITEE_PLANNER_BUTTON_SPOTLIGHT_VIEWED =
  'trello_ui_spotlight_viewed_newinviteeplannerbuttonspotlight_newinviteeplannerbuttonspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/d8ebb9ff-167c-45e8-8800-b8f3757cd7fd
export const NEW_INVITEE_PLANNER_PANEL_SPOTLIGHT_VIEWED =
  'trello_ui_spotlight_viewed_newinviteeplannerpanelspotlight_newinviteeplannerpanelspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/2532b8bc-94fb-487f-9f49-e8ca303576b3
export const NEW_INVITEE_INBOX_BUTTON_SPOTLIGHT_VIEWED =
  'trello_ui_spotlight_viewed_newinviteeinboxbuttonspotlight_newinviteeinboxbuttonspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/3c51f4c6-0542-4adf-b0e5-a41c1d6b1d2e
export const NEW_INVITEE_INBOX_PANEL_SPOTLIGHT_VIEWED =
  'trello_ui_spotlight_viewed_newinviteeinboxpanelspotlight_newinviteeinboxpanelspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/94ae8961-0bc1-441d-aeb0-a46f99aa9e27
export const TRELLO_HAS_VIEWED_CONNECT_CHROME_INLINE_DIALOG =
  'trello_has_viewed_connectChromeInlineDialog';

// https://data-portal.internal.atlassian.com/targeting/traits/d3693a6d-3022-45f0-b10d-cc25e6f0f709
export const TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_BROWSER_EXTENSION =
  'trello_has_used_inbox_quick_capture_browser_extension';

// https://data-portal.internal.atlassian.com/targeting/traits/4f4ffab3-ff00-409b-8801-f16cc4c73a46
export const TRELLO_TRACK_CARD_ADDED_BROWSEREXTENSION_CHANGED =
  'trello_track_card_added_browserextension_changed';

// https://data-portal.internal.atlassian.com/targeting/traits/ca17643b-265f-47ba-8ad2-3fdfdba7d7fd
export const TRELLO_VIEWED_CHROME_QC_HIGHLIGHT_OVER_21_DAYS_AGO =
  'trello_viewed_chrome_qc_highlight_over_21_days_ago';

// https://data-portal.internal.atlassian.com/targeting/traits/75cf9145-19f1-4b6c-b9f1-a66574a87df1
export const TRELLO_UI_SPOTLIGHT_VIEWED_FEATUREANNOUNCEMENTINTROSPOTLIGHT_CHANGED =
  'trello_ui_spotlight_viewed_featureannouncementintrospotlight_changed';

export const TRELLO_UI_BUTTON_CLICKED_NEWFEATURECTA_FEATURE_ANNOUNCEMENT_FIRST_TIME =
  'trello_ui_button_clicked_newfeaturecta_feature_announcement_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/0820179b-ace7-4b95-acd7-24ab9e3490bc
export const TRELLO_USER_HAS_ANDROID_APP_USAGE_SINCE_2024 =
  'trello_user_has_android_app_usage_since_2024';

// https://data-portal.internal.atlassian.com/targeting/traits/60183f82-a8d3-4a38-8edf-5d493364916c
export const TRELLO_USER_HAS_IOS_APP_USAGE_SINCE_2024 =
  'trello_user_has_ios_app_usage_since_2024';

export const TRELLO_UI_SPOTLIGHT_VIEWED_PLANNERDISCOVERYSPOTLIGHT_FIRST_TIME =
  'trello_ui_spotlight_viewed_plannerdiscoveryspotlight_plannerdiscoveryspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/eb55968b-35fd-47d3-bb8a-54d5023b183b
export const TRELLO_AUTOMATION_CLICKED_MENUITEM_BUTLERREPORTMENUITEM =
  'trello_automation_clicked_menuitem_butlerreportmenuitem';

// Test trait for use in tests - not a real trait
export const TEST_TRAIT = 'test_trait';

const TRAIT_NAMES = [
  TRELLO_JIRA_CO_USERS_VNEXT,
  TRELLO_GA_MODAL_DATE,
  TRELLO_UI_BUTTON_CLICKED_ONBOARDINGLISTSPOTLIGHTDONEBUTTON_FIRST_TIME,
  TRELLO_UI_BUTTON_CLICKED_CONNECTACCOUNTBUTTON_PLANNERSCREEN_CHANGED,
  TRELLO_OPERATIONAL_PLANNERDISCOVERYSPOTLIGHTELIGIBILITY_EXCLUDED_CHANGED,
  SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH,
  TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH,
  SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_INFO_PANEL_QC_AAID,
  TRELLO_HAS_USED_PAID_PLANNER_ACTIONS_CHANGED,
  TRELLO_PLANNER_VIEWED_REAL_TIME_AAID,
  TRELLO_UI_SECTION_VIEWED_WORKSPACEWELCOMEMESSAGE_WORKSPACEBOARDSHOMESCREEN_FIRST_TIME,
  TRELLO_UI_FLAG_VIEWED_INVITEEBOARDWELCOMEMESSAGE_BOARDCREATIONSCREEN_FIRST_TIME,
  NEW_INVITEE_PLANNER_BUTTON_SPOTLIGHT_VIEWED,
  NEW_INVITEE_PLANNER_PANEL_SPOTLIGHT_VIEWED,
  NEW_INVITEE_INBOX_BUTTON_SPOTLIGHT_VIEWED,
  NEW_INVITEE_INBOX_PANEL_SPOTLIGHT_VIEWED,
  TRELLO_HAS_VIEWED_CONNECT_CHROME_INLINE_DIALOG,
  TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_BROWSER_EXTENSION,
  TRELLO_TRACK_CARD_ADDED_BROWSEREXTENSION_CHANGED,
  TRELLO_VIEWED_CHROME_QC_HIGHLIGHT_OVER_21_DAYS_AGO,
  TEST_TRAIT,
  TRELLO_UI_BUTTON_CLICKED_NEWFEATURECTA_FEATURE_ANNOUNCEMENT_FIRST_TIME,
  TRELLO_USER_HAS_ANDROID_APP_USAGE_SINCE_2024,
  TRELLO_USER_HAS_IOS_APP_USAGE_SINCE_2024,
  TRELLO_UI_SPOTLIGHT_VIEWED_PLANNERDISCOVERYSPOTLIGHT_FIRST_TIME,
  TRELLO_UI_SPOTLIGHT_VIEWED_FEATUREANNOUNCEMENTINTROSPOTLIGHT_CHANGED,
  TRELLO_AUTOMATION_CLICKED_MENUITEM_BUTLERREPORTMENUITEM,
] as const;

export type TraitName = (typeof TRAIT_NAMES)[number];
export type TraitValue = boolean | number | string;

// Helper function to check if a string is a valid trait name
export const isValidTraitName = (name: string): name is TraitName => {
  return TRAIT_NAMES.includes(name as TraitName);
};

export type Traits = Record<TraitName | string, TraitValue>;
